const updateStatusVerificationItems = {
  toastr: 'Updated Service Type',
  toastr1: ' has been updated successfully',
  toastrError: 'Service Type already registered',
  toastrError2: 'Enter another name'
};

export default updateStatusVerificationItems;
